module.exports = __webpack_public_path__ + "img/sec5_16.4b4399a3.jpg";